import { render, staticRenderFns } from "./UpdateCitizenModal.vue?vue&type=template&id=16ef5659&scoped=true&"
import script from "./UpdateCitizenModal.vue?vue&type=script&lang=js&"
export * from "./UpdateCitizenModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCitizenModal.vue?vue&type=style&index=0&id=16ef5659&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ef5659",
  null
  
)

export default component.exports